import { useTheme } from '../../context/ThemeContext'

import { FaSun, FaMoon } from 'react-icons/fa'

export function ThemeToggle() {
 const { theme, toggleTheme } = useTheme()
 const isDark = theme === 'dark'

 return (
  <button
   aria-label="Alternar tema"
   onClick={toggleTheme}
   className={`w-12 h-6 flex items-center rounded-full p-0 transition-all duration-500 ${
    isDark ? 'bg-gray-300 justify-start' : 'bg-[#f6d379] justify-end'
   }`}
   style={{ border: '1px solid black' }}
  >
   <div className="w-6 h-6 rounded-full flex items-center justify-center bg-white shadow-md">
    {isDark ? (
     <FaMoon className="text-gray-800" />
    ) : (
     <FaSun className="text-black" />
    )}
   </div>
  </button>
 )
}
